var map = {
	"./wallet_01_building.png": "3e57",
	"./wallet_01_cloud.svg": "c833",
	"./wallet_01_fx.png": "276c",
	"./wallet_01_lake.avif": "a831",
	"./wallet_01_lake.jpg": "4ff6",
	"./wallet_01_planet.svg": "52a4",
	"./wallet_02_advanced_1.png": "f919",
	"./wallet_02_advanced_2.png": "9538",
	"./wallet_02_advanced_3.png": "e23b",
	"./wallet_02_bg.jpg": "f131",
	"./wallet_02_biometric_1.png": "f9f3",
	"./wallet_02_biometric_2.png": "b368",
	"./wallet_02_complete_1.png": "cdbe",
	"./wallet_02_complete_2.png": "cdd6",
	"./wallet_02_cross_1.png": "a808",
	"./wallet_02_cross_2.png": "506f",
	"./wallet_02_cross_3.png": "07e3",
	"./wallet_02_evm_1.png": "81cd",
	"./wallet_02_evm_2.png": "861d0",
	"./wallet_02_evm_3.png": "61ef",
	"./wallet_02_fiat_1.png": "2c3a",
	"./wallet_02_fiat_2.png": "e07f",
	"./wallet_02_multi_1.png": "315f",
	"./wallet_02_multi_2.png": "7f03",
	"./wallet_02_nft_1.png": "810a",
	"./wallet_02_nft_2.png": "6e2e",
	"./wallet_02_non_1.png": "b091",
	"./wallet_02_non_2.png": "c628",
	"./wallet_02_non_3.png": "6609",
	"./wallet_02_pointshadow.png": "71a2",
	"./wallet_02_qris_1.png": "3ab5",
	"./wallet_02_qris_2.png": "7bd8",
	"./wallet_02_qris_3.png": "4932",
	"./wallet_02_slick_1.png": "aaaa",
	"./wallet_02_slick_2.png": "fb25",
	"./wallet_02_yourgateway_1.png": "dc4e",
	"./wallet_02_yourgateway_2.png": "5e1e",
	"./wallet_03_decentralized.png": "d7e4",
	"./wallet_03_f(x)bridge.png": "b700",
	"./wallet_03_marginx.png": "44e0",
	"./wallet_03_multi.png": "928b",
	"./wallet_03_pundix.png": "7443",
	"./wallet_03_safeguard.png": "74c6",
	"./wallet_04_create.png": "e8fd",
	"./wallet_04_download.png": "5007",
	"./wallet_04_experience.png": "6462",
	"./wallet_04_line.png": "994c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3297";